export default __webpack_public_path__ + "static/media/p-banner.0cef4025.png";